import ExpandableContainer from '../../ExpandableContainer'
import SelectCommandOptions from './SelectCommandOptions'
import AvailableColumnsTable from './AvailableColumnsTable'
import AssignActions from '../table/AssignActions'
import SelectColumnsTable from './SelectColumnsTable'
import SelectColumnsContext from './SelectColumnsContext'

const SelectColumns = () => {
    return (
        <SelectColumnsContext>
            <ExpandableContainer
                title="Select Columns"
                leftContent={<AvailableColumnsTable />}
                centerContent={<AssignActions mode="select" />}
                rightContent={<SelectColumnsTable />}
            >
                <SelectCommandOptions />
            </ExpandableContainer>
        </SelectColumnsContext>
    )
}

export default SelectColumns